import { createSvgIconComponent } from "../utils";

export const IconShirt = createSvgIconComponent({
  path: "M8 3.58A1.68 1.68 0 016.37 2.2h3.26A1.68 1.68 0 018 3.58zm7.9 1.8l-2.69-2.75a3.65 3.65 0 00-2.6-1.1H5.39a3.6 3.6 0 00-2.6 1.1L.1 5.38a.35.35 0 000 .48l2 2.04a.33.33 0 00.47 0l1.1-1.13v7.37a.34.34 0 00.33.34h8a.34.34 0 00.33-.34V6.77l1.1 1.14a.33.33 0 00.47 0l2-2.05a.35.35 0 000-.48z",
  fill: "currentColor",
  viewBox: "0 0 16 16",
});
